import React from "react";
import { Flex, IconButton, Text } from "@chakra-ui/react";
import { IoResize } from "react-icons/io5";
import { MdArrowForwardIos, MdArrowBackIosNew } from "react-icons/md";
import { Link } from "react-router-dom";
import { TOOTH_NUMBER_TO_TITLE } from "duck";
import { Chart, Charts } from "../../duck";
import { getHeader } from "./duck";

export interface HeaderProps {
  charts: {
    current: Chart | null;
    prev: Chart | null;
    next: Chart | null;
  };
  handleChartChange(chart: Chart | null): void;
  selection: Charts;
}

const Header: React.FC<HeaderProps> = ({
  charts,
  handleChartChange,
  selection
}) => {
  const { current, prev, next } = charts;

  if (!current) {
    return null;
  }

  const teethNumbers = getHeader(selection, current);

  return (
    <>
      <Link to={`./${current.tooth}`}>
        <IconButton
          position="absolute"
          top={2}
          left={3}
          size="sm"
          colorScheme="blackAlpha"
          variant="ghost"
          icon={<IoResize />}
          aria-label="Resize"
        />
      </Link>

      <Flex gap={3} justify="center">
        <IconButton
          size="sm"
          colorScheme="blackAlpha"
          variant="ghost"
          icon={<MdArrowBackIosNew />}
          aria-label="Previous"
          isDisabled={!prev}
          onClick={() => handleChartChange(prev)}
        />

        {selection.length === 1 ? (
          <Text>{`${current.tooth} - ${
            TOOTH_NUMBER_TO_TITLE[current.tooth]
          }`}</Text>
        ) : (
          teethNumbers.map(toothNumber => (
            <Text
              key={toothNumber}
              fontWeight={toothNumber === current.tooth ? "bold" : "medium"}
            >
              {toothNumber}
            </Text>
          ))
        )}

        <IconButton
          size="sm"
          colorScheme="blackAlpha"
          variant="ghost"
          icon={<MdArrowForwardIos />}
          aria-label="Next"
          isDisabled={!next}
          onClick={() => handleChartChange(next)}
        />
      </Flex>
    </>
  );
};

export default Header;
